export const moreSupport = {
    title: 'More support',
    happy: `
    <p>Everyone experiences times when they feel a bit down.</p>
    <p>
      If you have tried some of the activities list and have linked in
      with some of the community supports but still feel down and struggle
      to enjoy things, you can contact the Inverclyde Primary Care Mental
      Health Team on <a href="tel:01475558000">01475 558 000</a>.
    </p>
    <p>
      You can contact the team directly or ask your GP to make a referral.
    </p>
    <p>
      This team can offer an assessment and, if needed, short term
      psychological intervention.
    </p>
      `,
    relaxed: `<p>No one feels calm and relaxed all of the time, but if none of the things that you are doing to help you feel calm or
      relaxed are working, then it is a good idea to reach out for some additional support.</p>
    <p>Telephone support lines may be helpful: Alzheimer Scotland 24 hour helpline - <a href="tel:08008886678">0800 888
          6678</a> - or Silverline Scotland - <a href="tel:08004708090">0800 470 8090</a>.</p>
    <p>The Primary Care Mental Health Team (<a href="tel:01475558000">01475 558 000</a>) can also
      provide support with managing stress.</p>` ,
    active: `<p>Looking after your physical health will improve your mental health and wellbeing too. If you are taking good care of yourself but still feel that your energy levels are very low, it is a good idea to contact your GP, who will be able to assess if there is an underlying physical problem.</p>`,
    rested: `<p>Difficulty sleeping is a common issue and poor sleep has a big impact on how you feel overall. If none of the
    suggestions, activities or supports have helped to improve your sleep and problems have persisted for more than a
    month, you should consider contacting your GP.</p>`,
    interests: `<p>Starting a new activity can be daunting but the rewards can be great! If you feel worried about starting something
    new or would like someone to help you link with things that you are interested in, you can either: </p>
<p>Try <a rel="noopener" href="https://inverclydelife.com/services/community-connectors" target="_blank"
        title="Inverclyde community connectors">Inverclyde Community Connectors</a> Speak to a local Community
    Connector <a href="tel:01475728628">01475 728628</a>
    or email <a rel="noopener" href="mailto:enquiries@yourvoice.org.uk" target="_blank">enquiries@yourvoice.org.uk</a>.
    They may be able to
    help you link in with local support services.</p>
<p>or</p>
<p>Speak to a Community Link Worker who works in your local GP practice: call your GP Practice, or call <a
        href="tel:01475711733">01475 711 733</a> or email <a rel="noopener" href="mailto:admin@cvsinverclyde.org.uk"
        target="_blank">admin@cvsinverclyde.org.uk</a></p>`,
}

export default moreSupport;